import { NewQuoteOrderButton, QuoteOrderButton, QuoteOrderButtonCancel, QuoteOrderDownloadButtonPDF, QuoteOrderDownloadPdfTemplateButton, QuoteOrderDuplicateButton, QuoteOrderVersionsSelector, QuoteOrderCommentsButton, QuoteOrderShareButton } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderQuoteLayout/QuoteOrderButtons'
import { getBasePath } from '../../../../../../../../../../utils/globals/link'
import { checkQuoteFromOrderAllOk } from '../../../../../../../../../../utils/globals/order/order'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { useLocation } from 'react-router'
import { SellPdfPreview, SellQuickAccessButton } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellLayout/SellButtons'
import { QuoteOrderStatusInversed } from '@teinor/erp/types/company/order/quote/quoteOrder'
import { useMemo } from 'react'
import { OrderStepButtonsDefaultBaseComponent, OrderStepButtonsNewStyleBaseComponent } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent'
import { OrderStepButtonsBase, OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import { OrderDivideIntoChaptersButton, OrderProductTypesButton, OrderVariablesButton } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtons'

const QuoteOrderWaitingResponseStepButtons: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, urls, ...rest }) => {
    const location = useLocation()
    return (
        <div className='flex items-center relative gap-5 flex-wrap'>
            <OrderStepButtonsDefaultBaseComponent {...{ data, onSubmit, urls, hookFunction: useQuoteOrderWaitingResponseStepButtonsLogic, ...rest }} />
            <div className='absolute top-9 right-0 order_version_selector'>
                {data?.header?.version > 1 ? <QuoteOrderVersionsSelector url={getBasePath(location.pathname, 'single')} versions={data?.header?.versions} currentValue={data?.header?.id} /> : null}
            </div>
        </div>
    )
}

const useQuoteOrderWaitingResponseStepButtonsLogic = ({ data, onSubmit, urls, isReadOnly }: OrderStepButtonsBaseComponentProps) => {
    const { t } = useTwinTranslation()
    const name = 'quote_order_waiting_response_step_buttons'
    const Order = data?.header
    const OrderId = Order?.id
    const isLast = data?.header?.is_last
    const isPublicToken = data.header.publicToken
    const ShippingServiceId = data.header?.OrderShipping?.ShippingServiceId
    let infoMessageQuote = checkQuoteFromOrderAllOk(data, t)
    const hideSellQuickAccesButton = !Order?.QuoteOrderId && !Order?.SellOrderId && !Order?.SellDeliveryNoteId && !Order?.SellInvoiceId && !Order?.WorkSheetId && !Order?.relatedSellOrders?.length && !Order?.relatedSellDeliveryNotes?.length && !Order?.relatedSellInvoices?.length && !Order?.relatedWorkSheets?.length

    const defaultButtons = [{ "id": "acceptQuote" }, { "id": "cancelQuote" }, { "id": "previewQuote" }, { "id": "downloadQuote" }, { "id": "shareQuoteOrder" }, { "id": "quoteOrderComments" }, { "id": "createNewVQuote" }]

    const quoteOrderText = t('acceptQuote', 'Aceptar presupuesto')
    const quoteOrderCancelText = t('cancelQuote', 'Cancelar presupuesto')
    const quoteOrderShareText = t('ShareQuote', 'Compartir presupuesto')
    const quoteOrderUnshareText = t('quoteSharedInformation', 'Información sobre el presupuesto compartido')
    const quoteOrderCommentsText = t('conversationWithCustomer', 'Conversación con el cliente')
    const newQuoteOrderText = t('createNewQuoteVersion', 'Crear nueva versión del presupuesto')
    const quoteOrderDuplicateText = t('duplicateQuote', 'Duplicar presupuesto')
    const sellQuickAccessText = t('quickAccess', 'Acceso rápido')
    const sellPdfPreviewText = t('previewPdf', 'Previsualizar PDF')
    const quoteOrderDownloadPdfTemplateText = t('downloadSelectingPdfTemplate', 'Descargar seleccionando plantilla PDF')
    const quoteOrderDownloadButtonPDFText = t('downloadPdf', 'Descargar PDF')
    const quoteOrderDivideIntoChaptersText = t('divideIntoChapters', 'Dividir en capítulos')
    const quoteOrderVariablesText = t('variables', 'Variables')
    const quoteOrderProductTypesText = t('valueProductTypes', 'Valor tipos de producto')

    const ButtonComponents: OrderStepButtonsBase = useMemo(() => {
        return {
            acceptQuote: {
                component: QuoteOrderButton,
                extraProps: {
                    title: quoteOrderText,
                    id: 'acceptQuote',
                    disabled: false,
                    url: urls?.quoteOrder,
                    onSubmit, 
                    infoMessage: infoMessageQuote || '',
                    ShippingServiceId,
                    OrderId,
                    orderStatus: QuoteOrderStatusInversed['accepted']
                }
            },
            cancelQuote: {
                component: QuoteOrderButtonCancel,
                extraProps: {
                    title: quoteOrderCancelText,
                    id: 'cancelQuote',
                    disabled: false,
                    url: urls?.quoteOrder,
                    onSubmit,
                    infoMessage: infoMessageQuote || '',
                    ShippingServiceId,
                    OrderId,
                    orderStatus: QuoteOrderStatusInversed['denied']
                }
            },
            shareQuoteOrder: {
                component: QuoteOrderShareButton,
                showButton: isLast,
                extraProps: {
                    title: isPublicToken ? quoteOrderUnshareText : quoteOrderShareText,
                    id: 'shareQuoteOrder',
                    onSubmit,
                    OrderId,
                    allRowData: data
                }
            },
            quoteOrderComments: {
                component: QuoteOrderCommentsButton,
                extraProps: {
                    title: quoteOrderCommentsText,
                    id: 'quoteOrderComments',
                    onSubmit,
                    allRowData: data
                }
            },
            createNewVQuote: {
                component: NewQuoteOrderButton,
                extraProps: {
                    title: newQuoteOrderText,
                    id: 'createNewVQuote',
                    disabled: false,
                    url: urls?.newQuoteOrder,
                    onSubmit,
                    infoMessage: infoMessageQuote || '',
                    ShippingServiceId,
                    OrderId,
                    orderStatus: 0
                }
            },
            duplicateQuoteOrder: {
                component: QuoteOrderDuplicateButton,
                extraProps: {
                    id: 'duplicateQuoteOrder',
                    allRowData: data,
                    title: quoteOrderDuplicateText
                }
            },
            quickAccess: {
                component: SellQuickAccessButton,
                showButton: !hideSellQuickAccesButton,
                extraProps: {
                    id: 'quickAccess',
                    Order,
                    title: sellQuickAccessText
                }
            },
            previewQuote: {
                component: SellPdfPreview,
                extraProps: {
                    title: sellPdfPreviewText,
                    id: 'previewQuote',
                    Order,
                    typeTemplate: 'quoteOrder'
                }
            },
            downloadQuotePDFTemplate: {
                component: QuoteOrderDownloadPdfTemplateButton,
                extraProps: {
                    title: quoteOrderDownloadPdfTemplateText,
                    id: 'downloadQuotePDFTemplate',
                    key: 'downloadQuotePDFTemplate',
                    Order
                }
            },
            downloadQuote: {
                component: QuoteOrderDownloadButtonPDF,
                extraProps: {
                    title: quoteOrderDownloadButtonPDFText,
                    id: 'downloadQuote',
                    Order
                }
            },
            divideIntoChaptersQuote: {
                component: OrderDivideIntoChaptersButton,
                extraProps: {
                    title: quoteOrderDivideIntoChaptersText,
                    id: 'divideIntoChaptersQuote',
                    allRowData: data,
                    isReadOnly,
                    onSubmit,
                }
            },
            variablesQuote: {
                component: OrderVariablesButton,
                extraProps: {
                    title: quoteOrderVariablesText,
                    id: 'variablesQuote',
                    allRowData: data,
                    isReadOnly,
                    onSubmit,
                }
            },
            quoteProductTypes: {
                component: OrderProductTypesButton,
                extraProps: {
                    title: quoteOrderProductTypesText,
                    id: 'quoteProductTypes',
                    allRowData: data,
                    onSubmit,
                    isReadOnly
                }
            },
        }
    }, [quoteOrderText, quoteOrderCancelText, isLast, quoteOrderCommentsText, newQuoteOrderText, sellPdfPreviewText, quoteOrderDownloadButtonPDFText, quoteOrderDownloadPdfTemplateText, OrderId, ShippingServiceId, data, infoMessageQuote, onSubmit, urls?.newQuoteOrder, urls?.quoteOrder, quoteOrderShareText, quoteOrderUnshareText, isPublicToken, sellQuickAccessText, quoteOrderDuplicateText, Order, hideSellQuickAccesButton, quoteOrderDivideIntoChaptersText, quoteOrderVariablesText, isReadOnly, quoteOrderProductTypesText])

    return { ButtonComponents, name, defaultButtons }
}

export const QuoteOrderWaitingResponseStepButtonsNew: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, ...rest  }) => {
    const location = useLocation()
    return (
        <div className='flex order_config_buttons_parent items-center relative gap-5 flex-wrap'>
            <OrderStepButtonsNewStyleBaseComponent {...{ data, onSubmit, hookFunction: useQuoteOrderWaitingResponseStepButtonsLogic, ...rest }} />
            <div className='absolute top-9 right-0 order_version_selector'>
                {data?.header?.version > 1 ? <QuoteOrderVersionsSelector url={getBasePath(location.pathname, 'single')} versions={data?.header?.versions} currentValue={data?.header?.id} /> : null}
            </div>
        </div>
    )
}

export default QuoteOrderWaitingResponseStepButtons